import { ProductCategory, ProductStatus } from "../types/shared/types/shared/products.js";
import { TealiumEventPropertiesProvider, useTealiumEventProperties } from "./events/event-properties-provider.js";
import { useDispatchTrackClickEvent } from "./events/use-track-click-event.js";
import { dispatchTrackErrorEvent, useDispatchTrackErrorEvent, useTrackErrorEvent } from "./events/use-track-error-event.js";
import { dispatchTrackEvent, useDispatchTrackEvent, useTrackEvent } from "./events/use-track-event.js";
import { useDispatchTrackPageView, useTrackPageView } from "./events/use-track-page-view.js";
export {
  ProductCategory,
  ProductStatus,
  TealiumEventPropertiesProvider,
  dispatchTrackErrorEvent,
  dispatchTrackEvent,
  useDispatchTrackClickEvent,
  useDispatchTrackErrorEvent,
  useDispatchTrackEvent,
  useDispatchTrackPageView,
  useTealiumEventProperties,
  useTrackErrorEvent,
  useTrackEvent,
  useTrackPageView
};
//# sourceMappingURL=events.js.map
